module.exports = __webpack_public_path__ + "img/387-26617a.png";